import { render } from "./ClickReveal.vue?vue&type=template&id=4640dc4a"
import script from "./ClickReveal.vue?vue&type=script&lang=js"
export * from "./ClickReveal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__